import React, { forwardRef, useState, useEffect, useImperativeHandle } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
        theme.palette.mode === "dark"
            ? "0 0 0 1px rgb(16 22 26 / 40%)"
            : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
        theme.palette.mode === "dark"
            ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
            : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
        outline: "2px auto rgba(19,124,189,.6)",
        outlineOffset: 2,
    },
    /*'input:hover ~ &': {
      backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background:
        theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },*/
}));

const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#000000",
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
        display: "block",
        width: 16,
        height: 16,
        backgroundImage: "radial-gradient(#fff,#fff 18%,transparent 22%)",
        content: '""',
    },
    /*'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },*/
});

function BpRadio(props) {
    return <Radio disableRipple color="default" checkedIcon={<BpCheckedIcon />} icon={<BpIcon />} {...props} />;
}
const RadioButtons = forwardRef((props, ref) => {
  const { value } = props;
  const [selectedValue, setSelectedValue] = useState(value);
  const [hasError, setHasError] = useState(false);

    useEffect(() => {
        console.log("RadioButtons selectedValue", selectedValue);
    }, [selectedValue]);

    useEffect(() => {
        setSelectedValue(value);
    }, [value]);

    const controlProps = (item) => ({
        checked: selectedValue === item,
        onChange: handleChange,
        value: item,
        name: "color-radio-button-demo",
        inputProps: { "aria-label": item },
    });

    useImperativeHandle(ref, () => ({
        validateForm() {
            if (selectedValue) {
                setHasError(false);
            } else setHasError(true);
        },
    }));

    const handleChange = (event) => {
        event.stopPropagation();
        event.preventDefault();
        console.log("radio :: ", event.target.value);
        setSelectedValue(event.target.value);
        props.onChange({ id: props.id, value: event.target.value });

        setHasError(false);
    };
    return (
        <FormControl fullWidth>
            <RadioGroup
                {...props}
                name="radio-buttons-group"
                onChange={handleChange}
                value={selectedValue}
                aria-label="radio-group">
                {props.options.map((column) => (
                    <Box
                        component="span"
                        sx={{
                            py: 0,
                        }}>
                        <FormControlLabel
                            sx={{ display: "flex", alignItems: "start" }}
                            /*value={props.selectedItems[0]==="" ? column.value : props.selectedItems[0]}*/
                            value={column.value}
                            control={<BpRadio />}
                            label={
                                <Typography variant="body" sx={{ mt: 1 }}>
                                    <Box sx={{ fontSize: "14px", fontWeight: 400 }}>{column.key}</Box>
                                </Typography>
                            }
                        />
                        {column.value === selectedValue && column.componentOnSelect}
                    </Box>
                ))}
            </RadioGroup>
        </FormControl>
    );
});
export { RadioButtons };
